import { render } from "./Company.vue?vue&type=template&id=cf28e020&scoped=true"
const script = {}

import "./Company.vue?vue&type=style&index=0&id=cf28e020&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-cf28e020"

export default script